export const STORAGE_KEY_MERCHANT = 'marketing_ai_selected_location_id';
export const STORAGE_KEY_POS = 'pos_location_id';
export const STORAGE_KEY_LAST_USED = 'last_used_location_id';
